export default "__VITE_ASSET__IRqr5eBY__"